const action = "DEPLOYMENT_USAGE";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';

export const fetchUsageRequest = (payload) => {
    return {
        type: REQUEST,
        payload
    };
};

export const fetchUsageSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const clearUsageState = () => ({
  type: CLEAR
});

export const fetchUsageFailure = (error) => ({
  type: FAILURE,
  payload: error
});
